import React, { useEffect, useState } from 'react';
import styles from './ReportRename.module.scss';
import clsx from 'clsx';
import { ReactComponent as EditSvg } from '../../../../assets/svg/edit.svg';
import { Skeleton } from 'antd';

const RenameInput = (props) => {
  const { id, name, onEditClick, onEditFinish, isEditing, isLoading } = props;
  const [displayName, setDisplayName] = useState(name || '');

  useEffect(() => {
    if (name !== displayName) {
      setDisplayName(name || '');
    }
  }, [name]);

  const handleFinish = (e) => {
    const value = displayName.trim();
    if (value === '') return;
    onEditFinish({ ...e, target: { ...e.target, value } });
  };

  return (
    <div
      className={clsx(styles.draftName, isEditing && styles.isEditing)}
      onClick={(e) => e.stopPropagation()}
    >
      {isEditing ? (
        <input
          type="text"
          placeholder="Enter the draft name"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          onBlur={handleFinish}
          className={clsx(styles.rename, styles.title, isEditing && styles.isEditing)}
          maxLength={250}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleFinish(e);
            }
          }}
          onClick={(event) => event.stopPropagation()}
        />
      ) : (
        <div className={clsx(styles.name, styles.title)} title={displayName}>
          {typeof isLoading === 'undefined' ? (
            displayName || <Skeleton.Input active size={20} />
          ) : isLoading ? (
            <Skeleton.Input active size={20} />
          ) : (
            displayName
          )}
        </div>
      )}
      <div
        className={styles.editButton}
        onClick={(event) => {
          event.stopPropagation();
          onEditClick(event);
        }}
      >
        <EditSvg />
      </div>
    </div>
  );
};

export default RenameInput;
